export const stepperTypes = {
  stepSearchPutAway: 1,
  stepDocsMatchPutAway: 2,
  stepDescriptionPutAway: 3,
  stepLocateHistoryPutAway: 4,
  stepUnknowOt: 5,
  stepLPNSelection: 6
}

export const unknownFilterTypes = {
  priority: 1,
  sku: 2,
  supplier: 3,
  origin: 4
}
export const unknownFilterValues = [
  { value: 1, text: 'Prioridad' },
  { value: 2, text: 'SKU' }
]
